module.exports = __webpack_public_path__ + "static/BOTLogo-c24a262fedf15b18997b4e319a96b500.png";